import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-ms-measuring-types',
  templateUrl: './ms-measuring-types.component.html',
  styleUrls: ['./ms-measuring-types.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss' ]

})
export class MsMeasuringTypesComponent {

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) { }
  
}
